export default __webpack_public_path__ + "static/media/Definix-Trading-Challenge-26.fd50d2ce.png";